import { ISiteServicesApiClient } from '../SiteServicesApiClient';
import { AsyncStore } from './AsyncStore';

export class SupportCodeStore extends AsyncStore<string, undefined> {
    constructor(private siteApiClient: ISiteServicesApiClient) {
        super(() => this.siteApiClient.getSupportCode(), undefined);
    }

    /**
     * Replaces the support code with a new one, revoking the old. The response carries the new code, so it is
     * stored as is rather than loaded again.
     */
    async regenerate(): Promise<string> {
        return this.setItem(await this.siteApiClient.regenerateSupportCode());
    }
}

// Shared so the sidebar, the account page and the support hand-off cannot drift apart. ClassicPanel
// repeats it in its own template, which is the one copy the split between the two apps forces.
export const supportCodeExplanation =
    "Quote this support code if you need to email support from an address that isn't the registered account email. It changes weekly, whenever you change your password, and when you regenerate it.";

/**
 * What a copy control puts on the clipboard. Labelled so that, pasted into a ticket, the code reads as a
 * support code rather than a bare run of digits. `CustomerSearchService` recognises the label so an operator
 * can search on the pasted line, and ClassicPanel repeats it in its own template: change all three together.
 */
export function supportCodeClipboardText(code: string): string {
    return `Support code: ${code}`;
}
